/* Result page tab */
$(document).ready(function () {
  $('.result-tabs-nav a').click(function () {
    $('.result-tabs-nav li').removeClass('active');
    $('.result-tabs-nav ul').toggleClass('expanded');
    $(this).parent().addClass('active');
    var currentTab = $(this).attr('href');
    var newValue = currentTab.replace('#', '');
    $('.result-tabs-content .wrapper-result').hide();
    $('.wrapper-result.result-page[data-tab="' + newValue + '"]').show();
    return false;
  });
  
  <!--  Start - Press bar  AB Test -->
  if($('.featured-slider').length > 0) {
    $('.featured-slider').slick({
      autoplay: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev-custom">  </button>',
      nextArrow: '<button type="button" class="slick-next-custom">  </button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
  <!--  End - Press bar AB Test -->   
});

/* $(document).ready(function () {
  jQuery.getJSON("/cart.js?globalJS-onready", function (cart) {
    enableBundleFeature && slabHandle(cart);
    enableMysteryColorFeature && mystery_free_products(cart);
    childToParent(cart)
    parentToChild(cart)
  });
}); */

/* ================== Bundle announcement bar pupop JS ================== */
if($('.bundle-offer-popup').length > 0) {
  $(document).on('click', "#bundle-announcement-bar", function() {
    console.log("Click event===========")
    $("#bundle-announcement-bar + .bundle-offer-popup").fadeIn("fast");
  });
  $(".bundle-offer-popup .close-btn").on('click', function() {
    $("#bundle-announcement-bar + .bundle-offer-popup").fadeOut("fast");
  });
  
  $(document).mouseup(function(e) {
      var container = $(".bundle-offer-popup .offer-popup-container");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.parent().fadeOut("fast");
      }
  });
}
/* ================== End Bundle announcement bar offer pupop JS ================== */

$(document).ready(function () {
  function updateTimer() {
    var now = new Date(); // Get current date and time
    var targetTime = new Date(now); // Create a new date object
    var currentDate = new Date();
    if (currentDate.getHours() < 11) {
      // If before 6 PM, use today's date
      var options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
      var formattedDate = currentDate.toLocaleDateString('en-US', options);
      $(".delivery-text .day-time").text(formattedDate);
    } else {
      // If after 6 PM, use tomorrow's date
      currentDate.setDate(currentDate.getDate() + 1);
      var options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
      var formattedDate = currentDate.toLocaleDateString('en-US', options);
      $(".delivery-text .day-time").text(formattedDate);
    }
  }
  setInterval(updateTimer, 1000);
});

function getTheCookie(name) {
  const matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}
if(document.querySelector('#timer_min')) {
  if (getTheCookie('timer_min') > new Date().getTime()) {
    var time = getTheCookie('timer_min');
    var timer_min = setInterval(function () {
      var left = time - new Date().getTime();
      var min = Math.floor(left / 60000);
      // console.log(min);
      if (min < 10) {
        min = "0" + min;
      }
      var sec = Math.floor(left % 60000 / 1000);
      if (sec < 10) {
        sec = "0" + sec;
      }
      if (document.querySelector('#timer_min')) {
        document.querySelector('#timer_min').innerHTML = min + ':' + sec;
      }
      if (left < 1000) {
        clearInterval(timer_min);
        document.cookie = 'timer_min=""; path=/; domain=glamrdip.com; secure=true; expires=-1';
      }
    }, 1000);
  } else {
    document.cookie = 'timer_min=' + (new Date().getTime() + 900000) + '; path=/; domain=glamrdip.com; secure=true; expires=' + new Date(new Date().getTime() + 3600000 * 24).toUTCString();
    var time = new Date().getTime() + 900000;
    var timer_min = setInterval(function () {
      var left = time - new Date().getTime();
      var min = Math.floor(left / 60000);
      // console.log(min);
      if (min < 10) {
        min = "0" + min;
      }
      var sec = Math.floor(left % 60000 / 1000);
      if (sec < 10) {
        sec = "0" + sec;
      }
      if (document.querySelector('#timer_min')) {
        document.querySelector('#timer_min').innerHTML = min + ':' + sec;
      }
      if (left < 1000) {
        clearInterval(timer_min);
        document.cookie = 'timer_min=""; path=/; domain=glamrdip.com; secure=true; expires=-1';
      }
    }, 1000);
  }
}


/* ================== More colours in the color product page JS ================== */
$(".more-colours ._custom-color-li-main").click(function () {   
  $("._custom-color-ul-2").toggle();
});

$(document).on("click", ".more-colours ._custom-color-container .custom-layer", function () {
  let $checkbox = $(this).parent().find("._custom-color-checkbox");
  let select_img = $checkbox.attr("data-selected").split(":");
  let variantId = $checkbox.attr("data-vID");
  $(".custom-slider-img-container .custom-slider-img").empty();
  $(".custom-slider-img").removeClass("slick-initialized slick-slider slick-dotted");

  for (let i = 0; i < select_img.length; i++) {
    if (select_img[i] != undefined && select_img[i] != "") {
      let imgHtml = `
        <div>
          <div class="custom-slider-content">
            <img src="${select_img[i]}" class="custom-slider-item">
            <form action="/cart/add" method="post" class="custom-slider-form add-to-cart-form">
              <input type="hidden" name="id" value="${variantId}">
              <input type="hidden" name="quantity" value="1">
              <input type="submit" class="addtocart custom-slider-btn" data-loading-text="Adding to cart..." value="Add to Cart">
            </form>
          </div>
        </div>
      `;
      $(".custom-slider-img").append(imgHtml);
    }
  }

  $('.custom-slider-img').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    prevArrow: '<button class="custom-slick-arrow custom-slick-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"><path d="M23.75 12.375H1M1 12.375L12.375 1M1 12.375L12.375 23.75" stroke="#1E1E1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button class="custom-slick-arrow custom-slick-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"><path d="M1 12.375H23.75M23.75 12.375L12.375 1M23.75 12.375L12.375 23.75" stroke="#1E1E1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  });
  
  $('body, html').addClass('overflow-scroll');
  $(".color-product .custom-slider-container").fadeIn("fast");

  var forms = document.querySelectorAll('.add-to-cart-form');
  forms.forEach(function (form) {
    formDataWithAddToCart(form);
  });
});

// Category click functionality
$(".more-colours ._custom-color-li").click(function () {
  let categoryType = $(this).attr("data-color-type");
  let av = $(this).text();

  $(".more-colours ._custom-color-li-main span").text(av);
  $(".more-colours ._custom-color-ul-2").hide();
  $(".more-colours ._custom-color-container").removeClass("is-active");
  $(`.more-colours ._custom-color-container[data-color-type="${categoryType}"]`).addClass("is-active");
  $(".more-colours ._custom-color-li").removeClass("active");

  $(this).addClass("active");
});

// Close popup
$(".color-product .custom-slider-container").click(function () {
  $('body, html').removeClass('overflow-scroll');
  $(this).fadeOut("fast");
});

$(".color-product .custom-slider-img").click(function (e) {
  e.stopPropagation();
});

$('.color-product .custom-slider-img-container').on("click", ".custom-slider-cross", function () {
  $('body, html').removeClass('overflow-scroll');
  $(".color-product .custom-slider-container").fadeOut("fast");
});

/* ================== More colours in the color product page JS ================== */